import { safeGet } from "../utils/request-helpers";
import { route } from "ziggy-js";
export const getArtworkPreviewInfo = (artworkID, filters = {}) => {
    return safeGet(route('api.v1.artwork.preview', { artworkID }), filters);
};
